import { LoggedOutComponent } from './authentication/loggedout/loggedout.component';
import { CanDeactivateGuard } from './common/guard/can-deactivate.guard';
import { ForgotPassword1Component } from './authentication/forgot/forgot-password-1.component';
import { ForgotPassword2Component } from './authentication/forgot/forgot-password-2.component';
import { RegistrationConfirmationComponent } from './authentication/confirm/confirm-registration.component';
import { RegisterComponent } from './authentication/register/registration.component';
import { LogoutComponent } from './authentication/logout/logout.component';
import { HomeComponent } from './home/home.component';
import { NewPasswordComponent } from './authentication/newpassword/newpassword.component';
import { LoginComponent } from './authentication/login/login.component';
import { AppComponent } from './app.component';
import { Routes, RouterModule } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';


export const routes: Routes = [
    { path: '', component: HomeComponent, canDeactivate: [CanDeactivateGuard] },
    { path: 'home', redirectTo: '', pathMatch: 'full' },
    { path: 'loggedout', component: LoggedOutComponent },
    { path: 'login', component: LoginComponent },
    { path: 'logout', component: LogoutComponent },
    { path: 'register', component: RegisterComponent },
    { path: 'confirmRegistration/:email', component: RegistrationConfirmationComponent },
    { path: 'forgotPassword', component: ForgotPassword1Component },
    { path: 'forgotPassword/:email', component: ForgotPassword2Component },
    { path: 'newpassword/:email', component: NewPasswordComponent },
    { path: '**', component: HomeComponent , canDeactivate: [CanDeactivateGuard] }
];

export const AppRoutes: ModuleWithProviders<RouterModule> = RouterModule.forRoot(routes, { useHash: false });
